import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
  Platform, TextInput,
  ToastController
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {ConfigPage} from "../config/config";
import {VizixService} from "../../providers/vizix.service";
import {Storage} from "@ionic/storage";
import {SetupModel} from "../../models/LoginModel/SetupModel";
import {File} from "@ionic-native/file";
import {HttpErrorResponse} from "@angular/common/http";
import {ConfigurationThing} from "../../models/configurationThing";
import {isUndefined} from "util";
import {
  CONFIG_FILE_NAME,
  CONFIG_FOLDER_FILE,
  STORAGE_SET_UP_MODEL_TEMP,
  STORAGE_TIME_OFFSET, VALIDATION_INPUT_HOST, VALIDATION_INPUT_NUMBER, VALIDATION_INPUT_USER,
  VIZIX_EVENT_ID_LOGIN,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {UniqueDeviceID} from "@ionic-native/unique-device-id";
import {VizixEventItem} from "../../models/VizixEventItem";
import {VizixEventService} from "../../providers/vizix.event.service";

@IonicPage()
@Component({
  selector: 'page-setup',
  templateUrl: 'setup.html',
})
export class SetupPage {

  private tag = '[SETUP]';

  public secure: boolean = true;

  public clientId: string;
  public username: string;
  public password: string;

  public setup: SetupModel;
  public result: boolean;

  private alertInvalidStoreId: Alert;
  private alertError: Alert;
  private isAlert: boolean = false;
  public input_type: string = 'password';
  public show_password: boolean = false;
  private hasPortInHost;
  private loading;
  private httpPorts = "80|8080";
  private httpsPorts = "443";

  @ViewChild('inputHost') inputHostField: TextInput;
  @ViewChild('inputUser') inputUserField: TextInput;
  @ViewChild('inputStoreId') inputStoreIdField: TextInput;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public _toastCtrl: ToastController,
              private _vizixService: VizixService,
              private storage: Storage,
              private loadingCtrl: LoadingController,
              private file: File,
              private platform: Platform,
              private alertCtrl: AlertController,
              private uniqueDeviceID: UniqueDeviceID,
              private vizixEventService: VizixEventService,
              private cdr: ChangeDetectorRef) {
    this.setup = new SetupModel('http://', this.httpPorts, '', null);
    this.username = '';
    this.password = '';
    this.secure = false;

    this.initAlerts();
  }

  ionViewWillEnter() {
    this.cdr.reattach();
  }

  ionViewWillLeave() {
    this.cdr.detach();
  }

  ionViewDidLoad() {

    //Get clientId
    this.uniqueDeviceID.get()
      .then((uuid: any) => this.clientId = String(uuid))
      .catch((error: any) => this.clientId = 'web');

    this.platform.ready().then(() => {
      this.ExistsSetup();
    });

    this.vizixEventService.init(true);
  }

  initAlerts() {
    this.initAlertError();
    this.initAlertStoreIdNotValid();
  }

  // Alert that shows when there is an invalid store id
  initAlertStoreIdNotValid() {
    this.alertInvalidStoreId = this.alertCtrl.create({
      title: this.translate.instant('setup.alerts.invalid_store_id.title'),
      message: this.translate.instant('setup.alerts.invalid_store_id.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('setup.alerts.invalid_store_id.ok'),
          handler: () => {
            this.initAlertStoreIdNotValid(); // We call this recursively because the alert is destroyed on dismiss
          }
        },
      ]
    });
  }

  // Alert that shows when an error occurs
  initAlertError() {
    this.alertError = this.alertCtrl.create({
      title: this.translate.instant('setup.alerts.error.title'),
      message: this.translate.instant('setup.alerts.error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('setup.alerts.error.ok'),
          handler: () => {
            this.initAlertError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  onSubmit() {
    if (this.ValidateFields()) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('setup.loading.connecting')
      });
      this.loading.present();
      this.hasPortInHost = this.hostHasPort();
      this.login(0);
    }
  }

  login(position: number) {

    if (this.hasPortInHost) {
      this._vizixService.VizixInit(this.setup.host, "", this.setup.protocol, this.clientId);
    } else {
      this._vizixService.VizixInit(this.setup.host + ":" + this.setup.port.split("|")[position], "", this.setup.protocol, this.clientId);
    }

    this._vizixService.VizixLogin(this.username, this.password).subscribe((data: boolean) => {
        this.result = data
      },
      (err) => {
        console.error('VizixLogin', err);
        let error = err['error'] || err['message'];

        if (error instanceof ProgressEvent || (err instanceof HttpErrorResponse && (err.status == 404 || err.status == 0))) {
          let nextPort = this.setup.port.split("|")[(position + 1)];
          console.log(this.tag, "NEXT PORT", nextPort);
          if (!isUndefined(nextPort)) {
            this.login((position + 1));
          } else {
            this.alertError.present();
            this.loading.dismiss();
          }
        } else {
          this.loading.dismiss();
          let errorString: string = JSON.stringify(error);
          if (typeof errorString === 'string' && (errorString.includes('"error":') || errorString.includes('"message":'))) {
            let json = JSON.parse(errorString);
            this.password = '';
            this.showErrorAlert(json["error"] || json["message"]);
          } else {
            this.showErrorAlert(this.translate.instant('login.toasts.unknownError'));
          }
        }

      },
      () => {
        this._vizixService.setStoreId(this.setup.storeID);
        this._vizixService.VizixGetConfigList().subscribe((data: ConfigurationThing[]) => {
            this.loading.dismiss();
            this._vizixService.timestamp().subscribe((response: { offset: number, timestamp: number }) => {
              const local = new Date().getTime();
              const currentOffset = local - response.timestamp;
              localStorage.setItem(STORAGE_TIME_OFFSET, currentOffset.toString());
            });
            let setupToSave = new SetupModel(this.setup.protocol, this.setup.port, this._vizixService.baseHost, this.setup.storeID);
            this.storage.set(STORAGE_SET_UP_MODEL_TEMP, setupToSave).then(() => {
              this.storage.get(STORAGE_SET_UP_MODEL_TEMP).then((setupModel) => {
                console.log(this.tag, 'Storage Temp Setup Model', setupModel);
              });
            });
            if (data.length > 0) {
              this.navCtrl.push(ConfigPage, {configurations: data});
            }
            else {
              this.alertInvalidStoreId.present();
            }
          },
          err => {
            this.loading.dismiss();
            this.alertError.present();
          });
        this.saveLoginEvent();
      });
  }

  /*Check if the user put the port in the host if yes: use that port if not use the default port*/
  hostHasPort(): boolean {
    let hostSplited = this.setup.host.split(":");
    if (hostSplited.length == 2) {
      this.setup.port = hostSplited[1];
      // this.setup.host = hostSplited[0];
      return true;
    }
    else {
      if (this.secure) {
        this.setup.port = this.httpsPorts;
      } else {
        this.setup.port = this.httpPorts;
      }
    }
    return false;
  }

  secureChanged() {
    if (this.secure) {
      this.setup.protocol = 'https://';
      this.setup.port = this.httpsPorts;
    } else {
      this.setup.protocol = 'http://';
      this.setup.port = this.httpPorts;
    }
  }

  // Check if we have the file in the SD card (android)
  // so we get the information from there and init the vizix service. If we don't have both, we just leave the user to enter
  // the values.
  private ExistsSetup() {
    try {
      console.log(this.tag, 'SetupModel not found, searching external storage file'); // TODO: Move path to constants
      this.file.checkFile(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME).then(result => {
          if (result) {
            console.log(this.tag, 'File found, reading the values');
            this.file.readAsText(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME).then(fileStr => {
              console.log(this.tag, fileStr);
              var fileObj = JSON.parse(String(fileStr));
              console.log(this.tag, fileObj);
              this.secure = fileObj.URL.startsWith("https");
              // this.setup.host = fileObj.URL.split('//')[1].split(':')[0];
              this.setup.host = fileObj.URL.split('//')[1];
              // this.setup.port = fileObj.URL.split(':')[2];
              this.setup.protocol = fileObj.URL.split('//')[0] + '//';
              this.setup.storeID = fileObj.StoreID;
              console.log(this.tag, 'File setup applied'); // TODO: DELETE FILE?
            }, err => {
              console.log(this.tag, 'error reading file');
              console.log(this.tag, err);
            }).catch(error => console.log(this.tag, error));
          } else {
            console.log(this.tag, 'File not found, waiting user input');
          }
        },
        error => {
          console.log(this.tag, error);
        });
    } catch (exception) {
      console.log(this.tag, exception);
    }
  }

  private ValidateFields(): boolean {
    if (isUndefined(this.setup.host) || this.setup.host == null || this.setup.host == "") {
      this.showErrorAlert(this.translate.instant("setup.toasts.serverValid"));
      return false;
    }

    if (this.setup.storeID <= 0) {
      this.showErrorAlert(this.translate.instant("setup.toasts.invalidStoreId"));
      return false;
    }

    if (isUndefined(this.username) || this.username == null || this.username == "") {
      this.showErrorAlert(this.translate.instant("setup.toasts.userValid"));
      return false;
    }
    if (isUndefined(this.password) || this.password == null || this.password == "") {
      this.showErrorAlert(this.translate.instant("setup.toasts.pwdValid"));
      return false;
    }

    return true;
  }

  /*ShowToast(messageText: string) {
    let toast = this._toastCtrl.create({
      message: messageText,
      duration: 2500,
      position: 'bottom'
    });
    toast.present();
  } */

  showPassword() {

    this.show_password = !this.show_password;

    if (this.show_password) {
      this.input_type = 'text';
    } else {
      this.input_type = 'password';
    }

  }

  validateForm() {
    return !(this.setup.host && this.username && this.password && this.setup.storeID);
  }

  showErrorAlert(errorMessage) {
    if (!this.isAlert) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('login.alerts.login_error.title'),
        message: errorMessage,
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('login.alerts.login_error.ok'),
            handler: () => {
              this.isAlert = false;
              console.log(this.tag, 'Ok clicked');
            }
          }
        ]
      });
      this.isAlert = true;
      alert.onDidDismiss(() => {
        this.isAlert = false;
      });
      alert.present();
    }
  }

  onChangeValue() {
    this.cdr.detectChanges();
  }

  private saveLoginEvent() {
    this.vizixEventService.getVizixEventItemBase().then((vizixEvent: VizixEventItem) => {
      vizixEvent.action = VizixEventAction.NONE;
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.AUTHENTICATION;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.eventId = VIZIX_EVENT_ID_LOGIN;
      vizixEvent.activity = VizixEventActivity.LOGIN;
      this.vizixEventService.recordEvent(vizixEvent);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    })
  }

  onChangeKeyValue(event, from: string) {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression;
    switch (from) {
      case 'host':
        regExpression = new RegExp(VALIDATION_INPUT_HOST);
        break;
      case  'user':
        regExpression = new RegExp(VALIDATION_INPUT_USER);
        break;
      case 'storeId':
        regExpression = new RegExp(VALIDATION_INPUT_NUMBER);
        break;
    }
    let value;
    if (regExpression && !regExpression.test(<string>charPressed.toUpperCase())) {
      value = event.replace(charPressed, '');
    }
    else {
      value = event;
    }
    switch (from) {
      case 'host':
        this.setup.host = value;
        this.inputHostField.value = value;
        break;
      case  'user':
        this.username = value;
        this.inputUserField.value = value;
        break;
      case 'storeId':
        this.setup.storeID = value;
        this.inputStoreIdField.value = value;
        break;
    }
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/setup/setup.ts